import { matchPath } from 'react-router'

/**
 * Pages open to anyone, without signing in (the module guard is skipped for them).
 * Full paths, react-router patterns. The API is what decides what each of these pages can show.
 */
export const PUBLIC_PATHS = {
  emdia: ['/parcelas/pagar/:parUuid'],
  // /carreiras shows the landing without a session and "Meu painel" with one
  carreiras: [
    '/carreiras',
    '/carreiras/vagas',
    '/carreiras/vagas/:vagId',
    '/carreiras/historias',
    '/carreiras/historias/:slug',
    '/carreiras/parceiro',
  ],
  // Eventos is public (decision of 17/10/2026): only the actions require sign-in
  eventos: ['/eventos', '/eventos/todos', '/eventos/principal/:evtId', '/eventos/:evtId'],
  // public profile: /conquistas/:username, its lists and each item (id = public UUID)
  conquistas: [
    '/conquistas',
    '/conquistas/badges',
    '/conquistas/badges/:badId',
    '/conquistas/:username/*',
  ],
} as const

/**
 * Module paths that look like a public profile but belong to the signed-in student.
 * A username can never be one of these segments (the API blocks it).
 */
export const PRIVATE_PATHS = {
  emdia: [],
  // ':slug' and ':evtId' would swallow these pages
  carreiras: ['/carreiras/historias/enviar'],
  eventos: ['/eventos/meus'],
  conquistas: ['/conquistas/eu/*', '/conquistas/gamificacao', '/conquistas/criar-perfil'],
} as const

function matchesAny(pathname: string, paths: readonly string[]): boolean {
  return paths.some((path) => matchPath({ path, end: true }, pathname) !== null)
}

export function isPublicPath(
  pathname: string,
  publicPaths: readonly string[],
  privatePaths: readonly string[] = [],
): boolean {
  return !matchesAny(pathname, privatePaths) && matchesAny(pathname, publicPaths)
}
